<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M22.5 13.334a1.5 1.5 0 011.5-1.5h26.667a1.5 1.5 0 011.5 1.5V40a1.5 1.5 0 01-3 0V16.955L14.394 51.728a1.5 1.5 0 11-2.121-2.122l34.772-34.773H24a1.5 1.5 0 01-1.5-1.5z"/></svg>